import { useEffect } from 'react'
import { giftCardMobx } from '@mobxStore'
import { checkGCardCustomPageTitle, setGCardPageTitle } from '@common/utils/giftcard'

/** 礼品卡页面标题自定义 */
export const useGiftCardPageTitle = () => {
  useEffect(() => {
    if (checkGCardCustomPageTitle()) {
      setGCardPageTitle()
    }
  }, [giftCardMobx.decorationInfo?.purchaseDecorates?.customName?.name])
}
